import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import trainingModules from '../data/trainingModules';

const Training = () => {
  const navigate = useNavigate();
  const [completed, setCompleted] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/training/progress', {
      headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
    })
      .then(res => setCompleted((res.data || []).map(r => r.module_key)))
      .catch(() => setCompleted([]))
      .finally(() => setLoading(false));
  }, []);

  const startTour = (module) => {
    navigate(module.route, { state: { startTour: module.key } });
  };

  const readyModules = trainingModules.filter(m => m.status === 'ready');

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 800, margin: '0 0 6px', color: 'var(--text)' }}>🎓 Eğitim</h1>
        <p style={{ margin: 0, color: 'var(--text-muted)' }}>
          Bir modülü seçip "Öğren"e basın — sizi gerçek sayfaya götürüp adım adım nasıl kullanacağınızı gösteririz.
        </p>
      </div>

      {!loading && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
          {readyModules.map(m => {
            const isDone = completed.includes(m.key);
            return (
              <div key={m.key} className="card" style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ fontSize: '32px' }}>{m.icon}</div>
                <div style={{ fontSize: '16px', fontWeight: 700, color: 'var(--text)' }}>{m.label}</div>
                <div style={{ fontSize: '13px', color: 'var(--text-muted)', flex: 1 }}>{m.description}</div>
                <button
                  className={isDone ? 'btn btn-secondary' : 'btn btn-primary'}
                  onClick={() => startTour(m)}
                >
                  {isDone ? '✓ Tamamlandı — Tekrar İzle' : '▶️ Öğren'}
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Training;
